import StepTwo from "@/components/dashboard/withdrawMoney/StepTwo";

export default function WithdrawMoneyStepTwo() {
  return <StepTwo />;
}
